import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import {
    crmPipelines,
    crmStages,
    crmDeals,
    crmTags,
    crmActivities,
    crmNotes,
    crmPositions,
    crmAudit,
    crmUi,
    crmLeads,
} from './slices/crm'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        crmPipelines,
        crmStages,
        crmDeals,
        crmTags,
        crmActivities,
        crmNotes,
        crmPositions,
        crmAudit,
        crmUi,
        crmLeads,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
